import { inject, Injectable, InjectionToken } from '@angular/core';
import { ProductConfigurationConfigurable } from '../product-configuration-configurable';
import { ATTRIBUTE_TOKEN, ProductConfigurationConfigurableOptionValue } from './product-configuration-configurable-option-value';
export const VALUES_TOKEN = new InjectionToken<ProductConfigurationConfigurableOptionValue[]>('PRODUCT_CONFIGURABLE_OPTION_VALUES_TOKEN');

@Injectable()
export class ProductConfigurationConfigurableOption<
    TValue extends ProductConfigurationConfigurableOptionValue = ProductConfigurationConfigurableOptionValue
> {
    /**
     * Option value
     */
    values!: TValue[];

    /**
     * Option attribute
     */
    readonly attribute = inject(ATTRIBUTE_TOKEN);

    /**
     * Services
     */
    readonly productConfiguration = inject(ProductConfigurationConfigurable);

    setValues(values: TValue[]) {
        this.values = values;
    }
}
